import { render } from "./InfoBox.vue?vue&type=template&id=56c58a5e&ts=true"
import script from "./InfoBox.vue?vue&type=script&lang=ts"
export * from "./InfoBox.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/janvodila/Sites/sempermed/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__